/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFPartialYesNoEnum = {
    Yes: 'yes',
    No: 'no',
    Partial: 'partial'
} as const;
export type CRSFPartialYesNoEnum = typeof CRSFPartialYesNoEnum[keyof typeof CRSFPartialYesNoEnum];


export function CRSFPartialYesNoEnumFromJSON(json: any): CRSFPartialYesNoEnum {
    return CRSFPartialYesNoEnumFromJSONTyped(json, false);
}

export function CRSFPartialYesNoEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFPartialYesNoEnum {
    return json as CRSFPartialYesNoEnum;
}

export function CRSFPartialYesNoEnumToJSON(value?: CRSFPartialYesNoEnum | null): any {
    return value as any;
}

